export default {
  Title: 'Molecular Block',
  DateCreateFrom: 'Date Created From',
  DateCreateTo: 'To',
  DateReceiveFrom: 'Date Received From',
  DateReceiveTo: 'To',
  PathoNo: 'Patho No.',
  HLN: 'HLN',
  MLCStatus: 'MLC Status',
  PatientName: 'Patient Name',
  ReceivedDate: 'Received Date',
  Sex: 'Sex',
  Status: 'ML Status',
  Select: 'Select',
  Block: 'Block',
  Find: 'Find',
  BlockNo: 'Block No.',
  SlideNo: 'Slide No.',
  SentDate: 'Sent Date',
  SentTo: 'Sent To',
  Remark: 'Remark',
  CreateDate: 'Created Date',
  CreateUser: 'Created User',
  UpdateDate: 'Updated Date',
  UpdateUser: 'Updated User',
  buttonLevel2Save: 'Save',
  buttonLevel2Delete: 'Delete',
  buttonCancel: 'Void',
  buttonPrintBlock: 'Print Block',
  buttonComplete: 'Complete',
  buttonSent: 'Sent',
  buttonOpen: 'Open',
  buttonSlidePreparation: 'Slide Preparation',
  buttonStaining: 'Staining',
  HN: 'HN'
}
